import { render, staticRenderFns } from "./HumanResourceComponent.vue?vue&type=template&id=7c65e270&scoped=true&"
import script from "./HumanResourceComponent.vue?vue&type=script&lang=js&"
export * from "./HumanResourceComponent.vue?vue&type=script&lang=js&"
import style0 from "./HumanResourceComponent.vue?vue&type=style&index=0&id=7c65e270&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c65e270",
  null
  
)

export default component.exports